"use client";

import { c as _c } from "react/compiler-runtime";
import type { DehydratedState } from "@tanstack/react-query";
import { HydrationBoundary } from "@tanstack/react-query";
export function Hydrate(t0) {
  const $ = _c(3);
  const {
    state,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== state) {
    t1 = <HydrationBoundary state={state}>{children}</HydrationBoundary>;
    $[0] = children;
    $[1] = state;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}